import React, { useEffect, useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Checkbox, CircularProgress, FormControlLabel } from "@material-ui/core";
import ActionDialog from "../../ActionDialog";
import { editAgreementManagerOneTimeCommission } from "../../../../actions";
import { normalizePercentValue } from "../../../../util";
import { useManagementAction } from "../../../../hooks/useManagementAction";
import LocaleNumberField from "../../LocaleNumberField";

const ChangeManagerOneTimeCommission = ({ open, handleCloseDialog, user, fetchUser }) => {
  const { handleManagementAction } = useManagementAction();

  const initialManagerOneTimeCommission = normalizePercentValue(user?.contractAgent?.managerOneTimeCommission);
  const defaultManagerOneTimeCommission = normalizePercentValue(user?.contractAgent?.contractAgentClass?.managerOneTimeCommission);
  const [loading, setLoading] = useState(false);
  const [managerOneTimeCommission, setManagerOneTimeCommission] = useState(() => initialManagerOneTimeCommission);
  const [useDefault, setUseDefault] = useState(user.contractAgent.defaultManagerOneTimeCommission);

  const isMountedRef = useRef(true);
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const onFinish = () => {
    if (!isMountedRef.current) return;

    setLoading(false);
    handleCloseDialog();
  };

  const handleSubmit = async () => {
    let newManagerOneTimeCommission = null;
    if (managerOneTimeCommission !== null) {
      newManagerOneTimeCommission = managerOneTimeCommission / 100;
    }

    setLoading(true);
    await handleManagementAction({
      body: { editedUserId: user.id, managerOneTimeCommission: newManagerOneTimeCommission },
      managementAction: editAgreementManagerOneTimeCommission,
      onComplete: fetchUser,
      onFinish,
      successMessage: "app.edit.sucesfully",
    });
  };

  const handleClose = () => {
    setManagerOneTimeCommission(initialManagerOneTimeCommission);
    handleCloseDialog();
  };

  useEffect(() => {
    setManagerOneTimeCommission(useDefault ? null : initialManagerOneTimeCommission);
  }, [useDefault, initialManagerOneTimeCommission]);

  return (
    <ActionDialog
      title="app.edit"
      open={open}
      onAccept={handleSubmit}
      onClose={handleClose}
      textConfirm="app.edit"
      maxWidth="xs"
      disableConfirmButton={loading || managerOneTimeCommission === ""}
      textToConfirmation={"app.confirm.changeManagementCommission"}
    >
      <LocaleNumberField
        defaultValue={defaultManagerOneTimeCommission}
        disabled={loading || useDefault}
        endAdornment="%"
        label={"app.manager.managerOneTimeCommission"}
        min={0}
        max={100}
        fullWidth
        value={managerOneTimeCommission}
        setValue={setManagerOneTimeCommission}
      />

      <FormControlLabel
        disabled={loading}
        control={
          <Checkbox
            checked={useDefault}
            onChange={() => setUseDefault((prev) => !prev)}
            color="primary"
          />
        }
        label={<FormattedMessage id="app.manager.useDefault" />}
      />
      {loading && (
        <div style={{ textAlign: "center", marginTop: 12 }}>
          <CircularProgress />
        </div>
      )}
    </ActionDialog>
  );
};
export default ChangeManagerOneTimeCommission;
